
//#region Interfaces

//import { IDisclosureDeliberationModel } from "../models/DTO/DisclosureDeliberationModel";

export interface IApiEndpointBaseActions {
    Create?: string;
    GetAll?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;
}

export interface IApiEndpoints {
    Agenda?: IAgendaControllerEndpoint;
    Area?: IAreaControllerEndpoint;
    Attachment?: IAttachmentControllerEndpoint;
    BoardMeeting?: IBoardMeetingControllerEndpoint;
    Company?: ICompanyControllerEndpoint;
    DeliberationPhrases?: IDeliberationPhrasesControllerEndpoint;
    DirectorDeliberation?: IDirectorDeliberationControllerEndpoint;
    DisclosureDeliberation?: IDisclosureDeliberationControllerEndpoint;
    ProposalArea?: IProposalAreaControllerEndpoint;
    ProposalCompany?: IProposalCompanyControllerEndpoint;
    ProposalDirector?: IProposalDirectorControllerEndpoint;
    ProposalPresenter?: IProposalPresenterControllerEndpoint;
    Menu?: IMenuControllerEndpoint;
    Meeting?: IMeetingControllerEndpoint;
    Proposal?: IProposalControllerEndpoint;
    ProposalAttachment?: IProposalAttachmentControllerEndpoint;
    TemplateEmail?: ITemplateEmailControllerEndpoint;
    User?: IUserControllerEndpoint;
    UserCompanyPermission?: IUserCompanyPermissionControllerEndpoint;
}

export interface IAgendaControllerEndpoint {
    ConvertPdf?: string;
}

export interface IMenuControllerEndpoint extends IApiEndpointBaseActions {
    GetTreeViewMenu?: string;
}

export interface IProposalControllerEndpoint extends IApiEndpointBaseActions {
    GetProposalById?: string;
    GetProposals?: string;
    GetProposalByDbView?: string;
    DeliberateProposals?: string;
    DeliberateProposalsWithDirectors?: string;
    ProposalWorkFlowAction?: string;
    GetProposalsByCompany?: string;
    GetProposalsByCompanyStream?: string;
    GetProposalsByCompanyStreamView?: string;
    GetProposalsByStatus?: string;
    GetProposalsByStatusStream?: string;
    Reschedule?: string;
    ReorderingOfBoardMeetingProposals?: string;
    GetProposalsByBoardMeeting?: string;
    ConvertPdf?: string;
}

export interface IProposalAttachmentControllerEndpoint {
    Download?: string;
    DeleteZipFileFromStorage?: string;
    DeleteFile?: string;
    DownloadAttachmentsAsZip?: string;
    DownloadProposalAttachment?: string;
    DownloadProposalAttachments?: string;
}

export interface IUserControllerEndpoint extends IApiEndpointBaseActions {
    GetUserById?: string;
    GetUsers?: string;
    GetUsersProposal?: string;
    GetUserPermissions?: string;
    GetPermissionsUsers?: string;
    UserLoginByCompany?: string;
    GetUsersByCompany?: string;
    GetUsersStream?: string;
}

export interface IAreaControllerEndpoint extends IApiEndpointBaseActions {
    GetAreas?: string;
    GetAreasProposal?: string;
    GetAreaById?: string;
    GetAggregatedAreas?: string;
}

export interface IAttachmentControllerEndpoint extends IApiEndpointBaseActions {
    GetAttachments?: string;
    GetAttachmentById?: string;
}

export interface IBoardMeetingControllerEndpoint extends IApiEndpointBaseActions {
    GetBoardMeetings?: string;
    GetBoardMeetingById?: string;
    GetBoardMeetingsByCompanyId?: string;
}

export interface IMeetingControllerEndpoint extends IApiEndpointBaseActions {
    GetBoardMeetings?: string;
    GetBoardMeetingById?: string;
    GetBoardMeetingsByCompanyId?: string;
}

export interface ICompanyControllerEndpoint extends IApiEndpointBaseActions {
    GetCompanies?: string;
    GetCompanyById?: string;
}

export interface IDeliberationPhrasesControllerEndpoint extends IApiEndpointBaseActions {
    GetDeliberationPhrases?: string;
    GetDeliberationPhraseById?: string;
}

export interface IDirectorDeliberationControllerEndpoint extends IApiEndpointBaseActions {
    GetDirectorDeliberations?: string;
    GetDirectorDeliberationById?: string;
}

export interface IDisclosureDeliberationControllerEndpoint extends IApiEndpointBaseActions {
    GetDisclosureDeliberations?: string;
    GetDisclosureDeliberationById?: string;
    ShareProposal?: string;
}

export interface IProposalAreaControllerEndpoint extends IApiEndpointBaseActions {
    GetProposalAreas?: string;
    GetProposalAreaById?: string;
}

export interface IProposalCompanyControllerEndpoint extends IApiEndpointBaseActions {
    GetProposalCompanies?: string;
    GetProposalCompanyById?: string;
}

export interface IProposalDirectorControllerEndpoint extends IApiEndpointBaseActions {
    GetProposalDirectors?: string;
    GetProposalDirectorById?: string;
}

export interface IProposalPresenterControllerEndpoint extends IApiEndpointBaseActions {
    GetProposalPresenters?: string;
    GetProposalPresenterById?: string;
}

export interface ITemplateEmailControllerEndpoint extends IApiEndpointBaseActions {
    GetTemplatesEmail?: string;
    GetTemplateEmailById?: string;
}

export interface IUserCompanyPermissionControllerEndpoint extends IApiEndpointBaseActions {
    GetUserCompanyPermissions?: string;
    GetUserCompanyPermissionById?: string;
    CreateCollection?: string;
    UpdateCollection?: string;
    DeleteCollection?: string;
    SetUsersCompaniesPermissions?: string;
    GetPermissionsByCompany?: string;
    GetUserCompanyPermissionByUserId?: string;
}

//#endregion

//#region Concretes

export class ApiEndpointBaseActions implements IApiEndpointBaseActions {
    Create?: string;
    GetAll?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializer a base endpoint
     * @param baseUri {string} - base path of api, without "/api" (this stay in axios configuration).
     */
    constructor(baseUri: string) {

        if (!baseUri)
            throw new Error("base uri could not be null or empty.");

        this.Delete = `${baseUri}/Delete`;
        this.GetAll = `${baseUri}/GetAll`;
        this.Paginated = `${baseUri}/GetPaginatedList`;
        this.Create = `${baseUri}/Create`;
        this.Update = `${baseUri}/Update`;
    }
}

// Agenda
export class AgendaControllerEndpoint implements IAgendaControllerEndpoint {
    ConvertPdf?: string;

    constructor() {
        this.ConvertPdf = "Agenda/ConvertPdf";
    }
}

// Menu
export class MenuControllerEndpoint implements IMenuControllerEndpoint {
    Create?: string;
    GetAll?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;
    GetTreeViewMenu?: string;

    /**
     * Initializes base endpoint for Menu api controller;
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/Menu");
        this.Delete = base.Delete;
        this.GetAll = base.GetAll;
        this.GetTreeViewMenu = `/Menu/GetTreeViewMenu`;
        this.Paginated = base.Paginated;
        this.Create = base.Create;
        this.Update = base.Update;
    }
}

// Proposta
export class ProposalControllerEndpoint implements IProposalControllerEndpoint {
    Create?: string;
    GetAll?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;
    GetProposalById?: string;
    GetProposals?: string;
    GetProposalByDbView?: string;
    DeliberateProposals?: string;
    DeliberateProposalsWithDirectors?: string;
    ProposalWorkFlowAction?: string;
    GetProposalsByCompany?: string;
    GetProposalsByCompanyStream?: string;
    GetProposalsByCompanyStreamView?: string;
    GetProposalsByStatus?: string;
    GetProposalsByStatusStream?: string;
    Reschedule?: string;
    ReorderingOfBoardMeetingProposals?: string;
    GetProposalsByBoardMeeting?: string;
    ConvertPdf?: string;

    /**
     * Initializes base endpoint for Proposal api controller.
     */
    constructor() {
        const baseUri = "/Proposal";
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions(baseUri);
        this.Delete = base.Delete;
        this.GetAll = base.GetAll;
        this.GetProposals = `${baseUri}/GetProposals`;
        this.GetProposalByDbView = `${baseUri}/GetProposalByDbView`;
        this.GetProposalById = `${baseUri}/GetProposalById`;
        this.Paginated = base.Paginated;
        this.Create = base.Create;
        this.Update = base.Update;
        this.DeliberateProposals = `${baseUri}/DeliberateProposals`;
        this.DeliberateProposalsWithDirectors = `${baseUri}/UpdateProposalStatusForDirectorDeliberations`;
        this.ProposalWorkFlowAction = `${baseUri}/ProposalWorkFlowAction`;
        this.GetProposalsByCompany = `${baseUri}/GetProposalsByCompany`;
        this.GetProposalsByCompanyStream = `${baseUri}/GetProposalsByCompanyStream`;
        this.GetProposalsByCompanyStreamView = `${baseUri}/GetProposalsByCompanyStreamView`;
        this.GetProposalsByStatus = `${baseUri}/GetProposalsByStatus`;
        this.GetProposalsByStatusStream = `${baseUri}/GetProposalsByStatusStream`;
        this.Reschedule = `${baseUri}/ReplanProposal`;
        this.ReorderingOfBoardMeetingProposals = `${baseUri}/ReorderingOfBoardMeetingProposals`;
        this.GetProposalsByBoardMeeting = `${baseUri}/GetProposalsByBoardMeeting`;
        this.ConvertPdf = `${baseUri}/ConvertPdf`;
    }
}

// Anexos da Proposta
export class ProposalAttachmentControllerEndpoint implements IProposalAttachmentControllerEndpoint {
    Download?: string;
    DeleteZipFileFromStorage?: string;
    DeleteFile?: string;
    DownloadAttachmentsAsZip?: string;
    DownloadProposalAttachment?: string;
    DownloadProposalAttachments: string;

    /**
     * Initializes base endpoint for ProposalAttachment api controller.
     */
    constructor() {
        this.Download = "/ProposalAttachment/Download";
        this.DeleteFile = "/ProposalAttachment/DeleteFile";
        this.DeleteZipFileFromStorage = "/ProposalAttachment/DeleteZipFileFromStorage";
        this.DownloadProposalAttachment = "ProposalAttachment/DownloadProposalAttachment"
        this.DownloadProposalAttachments = "ProposalAttachment/DownloadProposalAttachments"
        this.DownloadAttachmentsAsZip = "ProposalAttachment/DownloadAttachments"
    }

}

// Usuário
export class UserControllerEndpoint implements IUserControllerEndpoint {
    Create?: string;
    GetAll?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;
    GetUserById?: string;
    GetUsers?: string;
    GetUsersProposal?: string;
    GetUserPermissions?: string;
    GetPermissionsUsers?: string;
    UserLoginByCompany?: string;
    GetUsersByCompany?: string;
    GetUsersStream?: string

    /**
     * Initializes base endpoint for User api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/User");
        this.Delete = base.Delete;
        this.GetAll = base.GetAll;
        this.GetUserPermissions = "/User/GetUserPermissions";
        this.GetPermissionsUsers = "/User/GetPermissionsUsers";
        this.GetUsersProposal = "/User/GetUsersProposal";
        this.GetUserById = "/User/GetUserById";
        this.GetUsers = "/User/GetUsers";
        this.Paginated = base.Paginated;
        this.Create = base.Create;
        this.Update = base.Update;
        this.UserLoginByCompany = "/User/UserLoginByCompany";
        this.GetUsersByCompany = "/User/GetUsersByCompany";
        this.GetUsersStream = "/User/GetUsersStream";
    }

}

// Área
export class AreaControllerEndpoint implements IAreaControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetAreas?: string;
    GetAreasProposal?: string;
    GetAreaById?: string;
    GetAggregatedAreas?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for Area api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/Area");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetAreas = "/Area/GetAreas";
        this.GetAreasProposal = "/Area/GetAreasProposal";
        this.GetAreaById = "/Area/GetAreaById";
        this.GetAggregatedAreas = "/Area/GetAggregatedAreas";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
    }
}

// Anexo
export class AttachmentControllerEndpoint implements IAttachmentControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetAttachments?: string;
    GetAttachmentById?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for Attachment api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/Attachment");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetAttachments = "/Attachment/GetAttachments";
        this.GetAttachmentById = "/Attachment/GetAttachmentById";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
    }
}

// Reunião de Diretoria
export class BoardMeetingControllerEndpoint implements IBoardMeetingControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetBoardMeetings?: string;
    GetBoardMeetingById?: string;
    GetBoardMeetingsByCompanyId?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for BoardMeeting api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/BoardMeeting");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetBoardMeetings = "/BoardMeeting/GetBoardMeetings";
        this.GetBoardMeetingById = "/BoardMeeting/GetBoardMeetingById";
        this.GetBoardMeetingsByCompanyId = "/BoardMeeting/GetBoardMeetingsByCompanyId";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
    }
}

// Empresa
export class CompanyControllerEndpoint implements ICompanyControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetCompanies?: string;
    GetCompanyById?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for Company api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/Company");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetCompanies = "/Company/GetCompanies";
        this.GetCompanyById = "/Company/GetCompanyById";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
    }
}

// Frases de Deliberação
export class DeliberationPhrasesControllerEndpoint implements IDeliberationPhrasesControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetDeliberationPhrases?: string;
    GetDeliberationPhraseById?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for DeliberationPhrases api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/DeliberationPhrases");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetDeliberationPhrases = "/DeliberationPhrases/GetDeliberationPhrases";
        this.GetDeliberationPhraseById = "/DeliberationPhrases/GetDeliberationPhraseById";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
    }
}

// Diretor de Deliberação
export class DirectorDeliberationControllerEndpoint implements IDirectorDeliberationControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetDirectorDeliberations?: string;
    GetDirectorDeliberationById?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for DirectorDeliberation api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/DirectorDeliberation");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetDirectorDeliberations = "/DirectorDeliberation/GetDirectorDeliberations";
        this.GetDirectorDeliberationById = "/DirectorDeliberation/GetDirectorDeliberationById";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
    }
}

// Divulgação de Deliberação
export class DisclosureDeliberationControllerEndpoint implements IDisclosureDeliberationControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetDisclosureDeliberations?: string;
    GetDisclosureDeliberationById?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;
    ShareProposal?: string;

    /**
     * Initializes base endpoint for DisclosureDeliberation api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/DisclosuresDeliberation");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetDisclosureDeliberations = "/DisclosuresDeliberation/GetDisclosureDeliberations";
        this.GetDisclosureDeliberationById = "/DisclosuresDeliberation/GetDisclosureDeliberationById";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
        this.ShareProposal = "/DisclosuresDeliberation/ShareProposal";
    }
}

// Lista Reuniões de Diretoria
// Reunião de Diretoria
export class MeetingControllerEndpoint implements IMeetingControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetBoardMeetings?: string;
    GetBoardMeetingById?: string;
    GetBoardMeetingsByCompanyId?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for BoardMeeting api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/Meeting");

        this.Create = "/BoardMeeting/Create";
        this.Update = "/BoardMeeting/Update";
        this.GetAll = base.GetAll;
        this.GetBoardMeetings = "/BoardMeeting/GetBoardMeetings";
        this.GetBoardMeetingById = "/BoardMeeting/GetBoardMeetingById";
        this.GetBoardMeetingsByCompanyId = "/BoardMeeting/GetBoardMeetingsByCompanyId";
        this.Delete = "/BoardMeeting/Delete";
        this.Paginated = base.Paginated;
    }
}

// Área da Proposta
export class ProposalAreaControllerEndpoint implements IProposalAreaControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetProposalAreas?: string;
    GetProposalAreaById?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for ProposalArea api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/ProposalArea");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetProposalAreas = "/ProposalArea/GetProposalAreas";
        this.GetProposalAreaById = "/ProposalArea/GetProposalAreaById";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
    }
}

// Empresa da Proposta
export class ProposalCompanyControllerEndpoint implements IProposalCompanyControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetProposalCompanies?: string;
    GetProposalCompanyById?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for ProposalCompany api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/ProposalCompany");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetProposalCompanies = "/ProposalCompany/GetProposalCompanies";
        this.GetProposalCompanyById = "/ProposalCompany/GetProposalCompanyById";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
    }
}

// Diretor da Proposta
export class ProposalDirectorControllerEndpoint implements IProposalDirectorControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetProposalDirectors?: string;
    GetProposalDirectorsById?: string;
    ById?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for ProposalDirector api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/ProposalDirector");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetProposalDirectors = "/ProposalDirector/GetProposalDirectors";
        this.GetProposalDirectorsById = "/ProposalDirector/GetProposalDirectorsById";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
    }
}

// Apresentador da Proposta
export class ProposalPresenterControllerEndpoint implements IProposalPresenterControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetProposalPresenters?: string;
    GetProposalPresentersById?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for ProposalPresenter api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/ProposalPresenter");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetProposalPresenters = "/ProposalPresenter/GetProposalPresenters";
        this.GetProposalPresentersById = "/ProposalPresenter/GetProposalPresentersById";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
    }
}

// Template de Email
export class TemplatesEmailControllerEndpoint implements ITemplateEmailControllerEndpoint {
    Create?: string;
    GetAll?: string;
    GetTemplatesEmail?: string;
    GetTemplateEmailById?: string;
    Update?: string;
    Delete?: string;
    Paginated?: string;

    /**
     * Initializes base endpoint for TemplateEmail api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("/TemplateEmail");

        this.Create = base.Create;
        this.Update = base.Update;
        this.GetAll = base.GetAll;
        this.GetTemplatesEmail = "/TemplateEmail/GetTemplatesEmail";
        this.GetTemplateEmailById = "/TemplateEmail/GetTemplateEmailById";
        this.Delete = base.Delete;
        this.Paginated = base.Paginated;
    }
}

// Permissão do usuário por empresa
export class UserCompanyPermissionControllerEndpoint implements IUserCompanyPermissionControllerEndpoint {
    Create?: string;
    CreateCollection?: string;
    GetAll?: string;
    GetUserCompanyPermissions?: string;
    GetPermissionsByCompany?: string;
    GetUserCompanyPermissionByUserId?: string;
    GetUserCompanyPermissionById?: string;
    Update?: string;
    UpdateCollection?: string;
    Delete?: string;
    DeleteCollection?: string;
    Paginated?: string;
    SetUsersCompaniesPermissions?: string;

    /**
     * Initializes base endpoint for UserCompanyPermission api controller.
     */
    constructor() {
        const base: IApiEndpointBaseActions = new ApiEndpointBaseActions("UserCompanyPermission");
        this.Delete = base.Delete;
        this.DeleteCollection = "/UserCompanyPermission/DeleteUsersCompaniesPermissions"
        this.GetAll = base.GetAll;
        this.GetUserCompanyPermissions = "/UserCompanyPermission/GetUserCompanyPermissions";
        this.GetPermissionsByCompany = "/UserCompanyPermission/GetPermissionsByCompany";
        this.GetUserCompanyPermissionByUserId = "UserCompanyPermission/GetUserCompanyPermissionByUserId"
        this.GetUserCompanyPermissionById = "/UserCompanyPermission/GetUserCompanyPermissionById";
        this.Paginated = undefined;
        this.Create = base.Create;
        this.CreateCollection = "/UserCompanyPermission/CreateUsersCompaniesPermissions";
        this.UpdateCollection = "/UserCompanyPermission/UpdateUsersCompaniesPermissions";
        this.SetUsersCompaniesPermissions = "UserCompanyPermission/SetUsersCompaniesPermissions"
    }
}

export default class ApiEndpoints implements IApiEndpoints {
    Agenda?: IAgendaControllerEndpoint | undefined;
    Area?: IAreaControllerEndpoint | undefined;
    Attachment?: IAttachmentControllerEndpoint | undefined;
    BoardMeeting?: IBoardMeetingControllerEndpoint | undefined;
    Company?: ICompanyControllerEndpoint | undefined;
    DeliberationPhrases?: IDeliberationPhrasesControllerEndpoint | undefined;
    DirectorDeliberation?: IDirectorDeliberationControllerEndpoint | undefined;
    DisclosureDeliberation?: IDisclosureDeliberationControllerEndpoint | undefined;
    ProposalArea?: IProposalAreaControllerEndpoint | undefined;
    ProposalCompany?: IProposalCompanyControllerEndpoint | undefined;
    ProposalDirector?: IProposalDirectorControllerEndpoint | undefined;
    ProposalPresenter?: IProposalPresenterControllerEndpoint | undefined;
    Meeting?: IMeetingControllerEndpoint | undefined;
    Menu?: IMenuControllerEndpoint | undefined;
    Proposal?: IProposalControllerEndpoint | undefined;
    ProposalAttachment?: IProposalAttachmentControllerEndpoint | undefined;
    TemplateEmail?: ITemplateEmailControllerEndpoint | undefined;
    User?: IUserControllerEndpoint | undefined;
    UserCompanyPermission?: IUserCompanyPermissionControllerEndpoint | undefined;

    /**
     * Initializers all Api endpoint;
     */
    constructor() {
        this.Agenda = new AgendaControllerEndpoint();
        this.Area = new AreaControllerEndpoint();
        this.Attachment = new AttachmentControllerEndpoint();
        this.BoardMeeting = new BoardMeetingControllerEndpoint();
        this.Company = new CompanyControllerEndpoint();
        this.DeliberationPhrases = new DeliberationPhrasesControllerEndpoint();
        this.DirectorDeliberation = new DirectorDeliberationControllerEndpoint();
        this.DisclosureDeliberation = new DisclosureDeliberationControllerEndpoint();
        this.ProposalArea = new ProposalAreaControllerEndpoint();
        this.ProposalCompany = new ProposalCompanyControllerEndpoint();
        this.ProposalDirector = new ProposalDirectorControllerEndpoint();
        this.ProposalPresenter = new ProposalPresenterControllerEndpoint();
        this.Meeting = new MeetingControllerEndpoint();
        this.Menu = new MenuControllerEndpoint();
        this.Proposal = new ProposalControllerEndpoint();
        this.ProposalAttachment = new ProposalAttachmentControllerEndpoint();
        this.TemplateEmail = new TemplatesEmailControllerEndpoint();
        this.User = new UserControllerEndpoint();
        this.UserCompanyPermission = new UserCompanyPermissionControllerEndpoint();
    }
}

//#endregion
